export function ClassificationIdSelectDummy() {
  return (
    <div>
      <select id="employee-select-PagibigReport">
      </select>
    </div>
  );
};

export function ClassificationSelectDummy() {
  return (
    <div className="mb-1">
      <label className="mb-1.5 block text-sm font-medium text-gray-600">
        Classification
      </label>
      
      <select
        disabled
        className="w-full box-border border border-solid border-gray-300 rounded-md px-3 py-2 text-gray-500 bg-gray-100 cursor-not-allowed"
      >
        <option value="">Select classification</option>
      </select>
    </div>
  );
}